import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core";

import { useIntl } from "react-intl";
import { Tipografia } from "../../../../_common";

function MentorIA({ classes, texto = "" }) {
  const intl = useIntl();
  if (!texto)
    return (
      <Tipografia cor="darkSecondaryText" italico style={{ padding: 20 }}>
        {intl.formatMessage({ defaultMessage: "Não há anotações" })}
      </Tipografia>
    );

  return (
    <p className={classes.text}>
      <Tipografia>{texto}</Tipografia>
    </p>
  );
}

MentorIA.propTypes = {
  classes: PropTypes.object,
  texto: PropTypes.string,
};

export default withStyles({
  text: { padding: "8px 16px", margin: 0, wordBreak: "break-word" },
})(MentorIA);
